import Adobe from "../providers/adobe";
import Facebook from "../providers/facebook";
import { GoogleSiteTag, GoogleAds } from "./google";
import * as MUTATIONS from "../../config/constants/mutation-types";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      consulta: [
        "Adobe.consulta",
        "Facebook.ofertaEmprendedores_consulta",
        "GoogleAds.consulta"
      ],
      ofertaEmprendedores: [
        "Adobe.ofertaEmprendedores",
        "Facebook.ofertaEmprendedores_oferta",
        "GoogleAds.ofertaEmprendedores"
      ],
      datosPersonales: ["Adobe.datosPersonales"],
      datosLaborales: ["Adobe.datosLaborales"],
      informacionAdicional: ["Adobe.informacionAdicional"],
      identidad: ["Adobe.identidad"],
      loadingVeridas: ["Adobe.loadingVeridas"],
      biometriaOK: ["Adobe.biometriaOK"],
      configuracion: ["Adobe.configuracion"],
      contrato: ["Adobe.contrato"],
      thank: ["Adobe.graciasEmprendedores"],
      mensaje: ["Adobe.mensaje"],
      mensajeErrorSolicitudCuenta: ["Adobe.mensaje"],
      celular: ["Adobe.celular"],
      usuarioClave: ["Adobe.usuarioClave"],
      thankOTP: ["Adobe.thankOTP"]
    },
    [MUTATIONS.ON_INTERNAL_LINK]: ["Adobe.internalLink"],
    [MUTATIONS.ADOBE_APP_STARTED]: ["Adobe.appStartedClick"]
  },
  providers: {
    Adobe,
    Facebook,
    GoogleSiteTag,
    GoogleAds
  }
};

export default pixelDb;
